<script setup lang="ts">
import type { PropType } from 'vue'
import type { Video } from '@/models/content'

defineProps({
  title: {
    type: String,
    default: null,
  },
  videos: {
    type: Array as PropType<Video[]>,
    required: true,
  },
})
</script>

<template>
  <section
    class="mx-auto max-w-content-container items-start gap-5 px-5 lg:mt-10 lg:flex"
    :class="{ 'lg:max-w-screen-lg': !title }"
  >
    <div v-if="title" class="mb-7 flex items-center gap-4 md:basis-1/4">
      <h2 class="hidden text-2xl font-bold lg:block">{{ title }}</h2>
      <hr class="hidden h-line-4 grow bg-s-900 lg:block" />
    </div>

    <div
      class="grid w-full grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3"
      :class="{ 'md:basis-3/4': title }"
    >
      <VerticalCard
        v-for="video in videos"
        :key="video.id"
        :slug="video.slug"
        content-type="video"
        :published-date="video.publishedDate"
        :duration="video.duration"
        :title="video.title"
        :excerpt="video.excerpt"
        :pills="[]"
        :cover-url="video.coverUrl"
        class="shrink-0 md:basis-1/3"
        data-testid="video-card"
      />
    </div>
  </section>
</template>
